export const LOCALE_PREFIX_ENTITY = 'components.Entity'
export const LOCALE_PREFIX_SIGNALS =
    'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.SyntheticIndicators'
